module.exports = __webpack_public_path__ + "static/img/iEP-2.93e2988.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/iEP-2.jpg
// module id = oWnk
// module chunks = 1